// extracted by mini-css-extract-plugin
module.exports = {"product-breakdown":"product_breakdown_product-breakdown__kFAkX","tooltip":"product_breakdown_tooltip__q4vNy","label":"product_breakdown_label__EGOYD"};